import { useEffect, useMemo } from 'react';

import { useGetStatisDataQuery } from '../../../slices/dashboardApiSlice';
import { socket } from '../../../socket';
import StatisticsCard from './StatisticsCard';

// 定义卡片显示顺序
const CARD_ORDER = ['今日营销', '总营销', '客户数量', '总欠款'];

const StatisticsCards = () => {
	const {
		data: statisData = [
			{
				title: '今日营销',
				value: 0,
				decimal: false,
				suffix: '',
				prefix: '¥',
				valueClassName: 'text-warning',
				linkText: '统计中',
			},
			{
				title: '总营销',
				value: 0,
				decimal: false,
				suffix: '',
				prefix: '¥',
				linkText: '统计中',
			},
			{
				title: '客户数量',
				value: 0,
				decimal: false,
				suffix: '',
				prefix: '',
				valueClassName: 'text-warning',
				linkText: '统计中',
			},
			{
				title: '总欠款',
				value: 0,
				decimal: false,
				suffix: '',
				prefix: '¥',
				valueClassName: 'text-danger',
				linkText: '统计中',
			},
		],
		isLoading: loadingStatsData,
		isFetching: fetchingStatsData,
		refetch: refetchStatsData,
	} = useGetStatisDataQuery(
		{},
		{
			pollingInterval: 30000,
			skipPollingIfUnfocused: true,
		},
	);

	useEffect(() => {
		if (!socket.connected) {
			socket.connect();
		}

		const handleRefreshStats = (payload) => {
			if (payload?.scope === 'finalCostVerification' || payload?.scope === 'processingOnly') return;
			refetchStatsData();
		};

		socket.on('refresh dashboard stats', handleRefreshStats);

		return () => {
			socket.off('refresh dashboard stats', handleRefreshStats);
		};
	}, [refetchStatsData]);

	const sortedStatisData = useMemo(() => {
		if (!statisData || statisData.length === 0) return statisData;

		return [...statisData].sort((a, b) => {
			const indexA = CARD_ORDER.indexOf(a.title);
			const indexB = CARD_ORDER.indexOf(b.title);
			if (indexA === -1) return 1;
			if (indexB === -1) return -1;
			return indexA - indexB;
		});
	}, [statisData]);

	return (
		<div className='dashboard-stat-cards-section'>
			<div className='dashboard-stat-cards'>
				{sortedStatisData.map((stat) => (
					<div key={stat.title} className='dashboard-stat-cards__col'>
						<StatisticsCard stat={stat} loadingStatsData={loadingStatsData} fetchingStatsData={fetchingStatsData} className='w-100' />
					</div>
				))}
			</div>
		</div>
	);
};

export default StatisticsCards;
